export default __webpack_public_path__ + "static/media/icon-verify-email.87e758f4.svg";